const COMPARE_ROWS_MODAL = 'app/modal/COMPARE_ROWS_MODAL';

export const GET_FULL_ROWS = 'GET_FULL_ROWS';
export const GET_FULL_ROWS_SUCCESS = `${GET_FULL_ROWS}/SUCCESS`;
export const GET_FULL_ROWS_FAILURE = `${GET_FULL_ROWS}/FAILURE`;

export default {
  COMPARE_ROWS_MODAL,

  GET_FULL_ROWS,
  GET_FULL_ROWS_SUCCESS,
  GET_FULL_ROWS_FAILURE
};
